import { UserProfileTypes } from 'services/requests';
import { useNavigate } from 'hooks/routes/useNavigate';
import { useQueryParams } from 'hooks/routes';
import { useCheckIraUserEmail } from 'hooks/api/iraUser/useCheckIraUserEmail';
import { useGetProfile } from 'hooks/api/login';
import { Parameters } from 'constants/queryParameters';
import SpecifyEmailModal from 'components/SpecifyEmailModal';
import { ModalProps } from 'components/Modal';

type Props = {
  onRequestClose: VoidFunction;
} & ModalProps;

const SpecifyEmail = ({ onRequestClose, ...props }: Props): JSX.Element => {
  const { mutateAsync: checkEmail } = useCheckIraUserEmail();
  const { data: profile } = useGetProfile();
  const { defaultEtzFee } = profile || {};
  const { toNewIraUserRole } = useNavigate();
  const employerId = useQueryParams(Parameters.employerId);

  const callbackFn = async (email: string) => {
    const user = await checkEmail(email);

    toNewIraUserRole({
      employerId,
      state: {
        ...user,
        etzFee: defaultEtzFee,
        profileType: UserProfileTypes.sepIra,
      },
    });
  };

  return (
    <SpecifyEmailModal
      callbackFn={callbackFn}
      onRequestClose={onRequestClose}
      {...props}
    />
  );
};

export default SpecifyEmail;
